import { signalRCore, SignalRCore } from './signalR.core';
import { SignalREventName, SignalREventsMap } from './types';

class SignalRService {
    private core: SignalRCore;

    constructor(core: SignalRCore) {
        this.core = core;
    }

    public get isConnected(): boolean {
        return this.core.isConnected;
    }

    public subscribeReconnected(handler: () => void): () => void {
        return this.core.subscribeReconnected(handler);
    }

    public subscribe<E extends SignalREventName>(
        event: E,
        handler: (data: SignalREventsMap[E]) => void
    ) {
        return this.core.subscribe(event, handler);
    }

    public unsubscribe<E extends SignalREventName>(
        event: E,
        handler: (data: SignalREventsMap[E]) => void
    ) {
        return this.core.unsubscribe(event, handler);
    }
}

export const signalRService = new SignalRService(signalRCore);
